<span class="role-ctrl__popover" [ngbPopover]="popoverTmpl" triggers="mouseenter:mouseleave" placement="bottom-right" *ngIf="isShowCIPopover">
  <span>
    <app-icon [glyph]="'warning-round'" [size]="'12'" [color]="'gray'" [class]="'icon--va-middle'"></app-icon>
  </span>
</span>

<ng-template #popoverTmpl>
  <div class="color-gray-dark" style="width: 163px">
    Сотрудник с совмещением<br />
    роли “Сервис-инженер”
  </div>
</ng-template>
